import ConsoleHelper from 'src/shared/helpers/consoleHelper';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { Colors } from 'src/shared/styles/colors';
import { useState } from 'react';
import { createRepair, Repair } from 'src/services/repair.service';
import { appConfig } from 'src/firebaseConf';

type RepairSummaryProps = {
  data: Repair;
  showSummary: boolean;
  onSubmitSuccess: () => void;
};

const RepairSummary = (props: RepairSummaryProps) => {
  const { data, showSummary, onSubmitSuccess } = props;
  const [errorMessage, setErrorMessage] = useState('');
  const { t } = useTranslation();

  const onPressConfirm = async () => {
    // ConsoleHelper.log('submitdata', submitdata);
    try {
      const res = await createRepair(appConfig.companyId, data);
      ConsoleHelper.log('RES createRepair::', res);
      setErrorMessage('');
      onSubmitSuccess();
    } catch (error) {
      ConsoleHelper.log('ERR createRepair::', error);
      setErrorMessage('Kunde inte spara registrering');
    }
  };

  return (
    <Box
      mt={2}
      sx={{
        display: showSummary ? 'flex' : 'none',
        flex: 1,
        flexDirection: 'column',
      }}
    >
      <Typography variant='h4'>{data.title}</Typography>
      {data.description?.length > 0 && <Typography>{data.description}</Typography>}
      <Box display='flex' mt={2} mb={1}>
        <Typography fontWeight={700} flex={4}>
          {t('category')}
        </Typography>
        <Typography textAlign='right' flex={6}>
          {data.category.name}
        </Typography>
      </Box>
      <Box display='flex' my={1}>
        <Typography fontWeight={700} flex={4}>
          {t('date')}
        </Typography>
        <Typography textAlign='right' flex={6}>
          {dayjs(data.date).format('YYYY-MM-DD')}
        </Typography>
      </Box>
      <Box display='flex' my={1}>
        <Typography fontWeight={700} flex={4}>
          {t('price')}
        </Typography>
        <Typography textAlign='right' flex={6}>
          {data.price} kr/{data.category.unit}
        </Typography>
      </Box>
      {/* <Box display='flex' my={1}>
        <Typography fontWeight={700} flex={4}>
          {t('time')}
        </Typography>
        <Typography textAlign='right' flex={6}>
          {data.time} min
        </Typography>
      </Box> */}
      <Box display='flex' my={1}>
        <Typography fontWeight={700} flex={4}>
          {t('quantity')}
        </Typography>
        <Typography textAlign='right' flex={6}>
          {data.quantity} {data.category.unit}
        </Typography>
      </Box>

      <Divider />

      <Box display='flex' my={2}>
        <Typography fontWeight={700} flex={4}>
          {t('sum')}
        </Typography>
        <Typography textAlign='right' flex={6}>
          {data.price * data.quantity} kr
        </Typography>
      </Box>
      {errorMessage?.length > 0 && (
        <Box display='flex' my={2}>
          <Typography flex={1}>{errorMessage}</Typography>
        </Box>
      )}
      <Box
        id='submit-container'
        sx={{
          display: 'flex',
          flex: 1,
          alignItems: 'flex-end',
          width: '100%',
        }}
      >
        <Button
          variant='contained'
          onClick={onPressConfirm}
          fullWidth
          sx={{
            height: '50px',
            '&.Mui-disabled': {
              background: Colors.GREEN_OPACITY,
            },
          }}
        >
          {t('confirmRegister')}
        </Button>
      </Box>
    </Box>
  );
};

export default RepairSummary;
